require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.array.species.js
// module id = 480
// module chunks = 0